import VAuctionForm from './VAuctionForm'
export default VAuctionForm